import {StyleSheet} from 'aphrodite';

import {FONT_PROXIMA_13} from 'styles/FontConstants';

export enum HelpGuideTab {
  BASICS = 'BASICS',
  COMPONENTS = 'COMPONENTS',
  EXAMPLES = 'EXAMPLES',
}

export const sharedStyles = StyleSheet.create({
  section: {
    marginBottom: '24px',
    ...FONT_PROXIMA_13,
  },
});
